import { Loader, Text3D, Text, useGLTF, ContactShadows, Float, PresentationControls, Gltf } from "@react-three/drei";
import Blob from "./Blob";
import { Ground, Particles, Video, Video2 } from "./Effects.js";
import { useSpring } from '@react-spring/core'
import React, { Suspense, useState } from 'react'
import { Canvas, useFrame, useThree } from '@react-three/fiber'
import { Environment, Bounds, useBounds } from '@react-three/drei'
import Laptop from "./Laptop";
import { Perf } from "r3f-perf";
import { MeshNormalMaterial } from "three";
import * as THREE from 'three'




export default function Experience() {

    // This flag controls open state, alternates between true & false
    const [open, setOpen] = useState(false)
    // We turn this into a spring animation that interpolates between 0 and 1
    const props = useSpring({ open: Number(open) })

    // Camera Variables
    const [started, setStarted] = useState(false)
    const vec = new THREE.Vector3();

    //Laptop resize on viewport change
    function Viewport() {
        const { viewport } = useThree()
        return (
            <group onClick={(e) => (e.stopPropagation(), setStarted(!started), setOpen(!open))} position-y={-0.75} position-z={-2} scale={viewport.width / 20} >
                <Laptop open={open} hinge={props.open.to([0, 1], [1.575, -0.425])} />
            </group>
        )
    }


    // Camera Animation
    const CameraAnimation = () => {

        useFrame(state => {
            if (started) {
                state.camera.lookAt(0, 0, 0);
                state.camera.position.lerp(vec.set(0.5, 1, 4), .008)
                state.camera.fov = 45
                state.camera.updateProjectionMatrix()     
            } else if (!started) {
                state.camera.lookAt(0, 0, 1);
                state.camera.position.lerp(vec.set(-2, 0.5, 4), .008)
                state.camera.fov = 45
                state.camera.updateProjectionMatrix()       
            }
        })
        return null;
    }



    return <>

        <Canvas dpr={[1, 2]} camera={{fov: 45, near: 0.1, far: 2000}} flat>

            <Suspense fallback={null}>
                <color args={['#000000']} attach='background' />

                <PresentationControls
                    rotation={[0.13, 0.1, 0]}
                    polar={[-0.4, 0.2]}
                    azimuth={[-1, 0.75]}
                    config={{ mass: 2, tension: 400 }}
                    snap={{ mass: 4, tension: 400 }}
                >
                    <Float rotationIntensity={0.4}>

                        {/* Screen Light */}


                        {/* load Laptop */}
                        {/* <Bounds fit observe damping={6}> */}
                        {/* <SelectToZoom> */}
                        <Viewport />
                        <CameraAnimation />

                        {/* </SelectToZoom> */}
                        {/* </Bounds> */}

                        {/* <Text3D
                            font="./Orbitron_Bold.json"
                            size={0.6}
                            position={[3, 1.3, -1]}
                            rotation-y={-1.6}
                            curveSegments={12}
                            bevelEnabled
                            bevelThickness={0.02}
                            bevelSize={0.02}
                            bevelOffset={0}
                            bevelSegments={5}
                            lineHeight={0.9}
                            letterSpacing={-0.025}
                        > */}
                        {`BSc.\nOgün\nYilmaz`}
                        {/* <meshBasicMaterial color={[1.5,1,4]} toneMapped={false}/> */}
                        {/* <meshStandardMaterial color="purple" emissive="purple" tonemapped={false}/> */}
                        {/* <meshNormalMaterial /> */}
                        {/* </Text3D> */}

                        {/* Easter egg */}
                        <Text
                            font="./Orbitron/static/Orbitron-Regular.ttf"
                            maxWidth={2}
                            scale={0.2}
                            rotation-y={-1.6}
                            lineHeight={0.9}
                            letterSpacing={-0.025}
                            position-x={3}
                            position-z={5}
                            position-y={0.8}
                        >
                            {'Human curiosity is limitless but this web app is not'}
                        </Text>

                        <Text3D
                            font="./Orbitron_Bold.json"
                            maxWidth={5}
                            scale={0.2}
                            rotation-x={[Math.PI * 1.8]}
                            lineHeight={0.9}
                            letterSpacing={-0.025}
                            position-x={-0.9}
                            position-z={1}
                            position-y={-0.9}
                            curveSegments={12}
                            bevelEnabled
                            bevelThickness={0.02}
                            bevelSize={0.02}
                            bevelOffset={0}
                            bevelSegments={5}

                        >
                            {'Click Laptop'}
                            <meshNormalMaterial />
                        </Text3D>

                        <Blob />

                        <Ground mirror={1} blur={[500, 100]} mixBlur={12} mixStrength={1.5} rotation={[-Math.PI / 2, 0, Math.PI / 2]} />

                        <Video />

                        <Video2 />

                        <Environment preset='city' />

                    </Float>



                </PresentationControls>

                {/* <ContactShadows
                    position-y={- 1.4}
                    opacity={1}
                    scale={5}
                    blur={2.4}
                /> */}
            </Suspense>

            {/* <Perf position="top-left" /> */}

        </Canvas>
        {/* <Loader /> */}

    </>

}

useGLTF.preload('./mac-draco.glb')

// function SelectToZoom({ children }) {
//     const api = useBounds()
//     return (
//         <group onClick={(e) => (e.stopPropagation(), e.delta <= 2 && api.refresh().fit())} onPointerMissed={(e) => e.button === 0 && api.refresh().fit()}>
//             {children}
//         </group>
//     )
// }




